import { Typography, Link, Button, ButtonStyles } from '@grammarly/badger-ui'
import { FormattedMessage } from 'react-intl'
import { withPublicAssetUrl } from '../../lib/utils/cdn'
import styles from './error-boundary.module.scss'
import { getConfig } from '../../config'

const { T1, C1, C2 } = Typography
const robot = withPublicAssetUrl('error/robot@2x.gif')
const supportNewRequestUrl = getConfig().support.urls.newRequest

interface ErrorFallbackProps {
  resetError: () => void
}

export const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  return (
    <main className={styles.container}>
      <img src={robot} width={155} height={215} alt="" />
      <T1 as="h1">
        <FormattedMessage
          id="errorBoundary.heading"
          description="Error Boundary - Heading"
          defaultMessage="Our AI-powered robots are recharging."
        />
      </T1>
      <C1 as="p">
        <FormattedMessage
          id="errorBoundary.copy"
          description="Error Boundary - Copy"
          defaultMessage="Grammarly is currently unavailable while we make upgrades{lineBreak}to improve the service for you. Please try again in a minute."
          values={{ lineBreak: <br /> }}
        />
      </C1>
      <Button className={ButtonStyles.GreenButtonWhiteText} onClick={resetError}>
        <FormattedMessage
          id="global.uiAction.tryAgain"
          description="Text for CTA that prompts user to try again"
          defaultMessage="Try again?"
        />
      </Button>
      <C2 as="p">
        <FormattedMessage
          id="errorBoundary.copyAfterCta"
          description="Error Boundary - Copy After CTA"
          defaultMessage="We apologize for the inconvenience and appreciate your patience.{lineBreak}For more information, please {contactLink}."
          values={{
            lineBreak: <br />,
            contactLink: (
              <Link href={supportNewRequestUrl}>
                <FormattedMessage
                  id="errorBoundary.copyAfterCta.ctaText"
                  description="Error Boundary - Copy After CTA - CTA Text"
                  defaultMessage="contact support"
                />
              </Link>
            ),
          }}
        />
      </C2>
    </main>
  )
}
